import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { useLocale } from '../../services/i18n/useLocale';
import { useWidget } from '../widgets';

import { Wrapper } from './NewsletterForm.styles';

import trads from './trads';

const submit = async (email, locale = 'fr') => {
  const resp = await fetch('/api/newsletter', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, locale }),
  });

  if (!resp.ok) {
    throw new Error(`subscription failed (${resp.status})`);
  }
};

const NewsletterForm = ({ submitIcon }) => {
  const intl = useLocale();
  const ref = useRef();
  const [status, setStatus] = useState(null);
  const infos = useWidget('newsletter');

  React.useEffect(() => {
    if (!status) {
      return;
    }
    const timeout = setTimeout(() => setStatus(null), 5000);

    return () => clearTimeout(timeout);
  }, [status]);

  const errorMessage =
    intl.formatMessage(trads.newsletterError) || 'Oups, une erreur est survenue';

  return (
    <Wrapper
      onSubmit={async (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
          await submit(ref.current.value, intl.locale);
          setStatus('added');
          ref.current.value = '';
        } catch (err) {
          setStatus('error');
        }
        return false;
      }}
    >
      <div className="field">
        <input
          ref={ref}
          type="email"
          placeholder={
            status === 'added'
              ? intl.formatMessage(trads.newsletterThankYou)
              : infos.placeholder
          }
          name="EMAIL"
          aria-label={infos.placeholder}
          className={status || ''}
        />
        {status === 'error' ? (
          <p className="error-message" role="alert">
            {errorMessage}
          </p>
        ) : null}
      </div>
      <button
        type="submit"
        className={classNames('clear simple-link block', {
          'simple-link': !submitIcon,
        })}
      >
        {submitIcon ? submitIcon : infos.submitText}
      </button>
    </Wrapper>
  );
};

export default NewsletterForm;
